// extracted by mini-css-extract-plugin
module.exports = {"selectbox":"swiperbox_selectbox_CJ8tw","item":"swiperbox_item_3eM5B"};